import React from 'react'

import { FormControl, Util } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

const { isEmailAddress, maxLength } = Util.validations

export const Email = () => {
  const { getLabel } = useIntl()

  return (
    <FormControl
      id="email"
      type="text"
      label={getLabel('appointments.selectionSteps.field.emailAddress.label')}
      errorMessage={getLabel('appointments.selectionSteps.field.emailAddress.error')}
      tooltip={getLabel('appointments.selectionSteps.field.emailAddress.tooltip')}
      validations={[isEmailAddress, maxLength(256)]}
      maxLength={256}
    />
  )
}
